import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { ReportService } from 'src/app/service/report.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-addnewreport',
  templateUrl: './addnewreport.component.html'
})
export class AddnewreportComponent implements OnInit {

  IsreadOnly: boolean = false;
  private genericValidator: GenericValidator;
  CompanyId: number = 0;
  AddReportForm: FormGroup;
  PanelName: string = '';
  SiteId: string = '';
  PanelId: string = '';
  MetermasterID: number = 0;
  SiteName: string = '';
  SiteList: any = [];
  PanelList: any = [];
  EnergymeterList: any = [];
  errorMsg: string = '';
  successMsg: string = '';
  newarr: any = [];
  displayMessage: { [key: string]: string } = {};
  windowheight: any;
  divHeight: number;
  tableHeight: number = 45;
  SetObj: { [key: string]: any } = {};
  list_of_functions: string[];
  MeterName: any;
  isDisplayCombo: boolean = true;
  private validationMessages: { [key: string]: { [key: string]: string } };
  DropDownList: any;
  ReporttypeList: any;

  onResize() {
    this.ResizeHeight();
  }

  // Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 70;
    this.tableHeight = this.divHeight - 20;
  }

  constructor(public dialogRef: MatDialogRef<AddnewreportComponent>, private formBuilder: FormBuilder, private commonservice: CommonService, private GSMConfigService: GSMConfigurationService,
    private reportservice: ReportService, private authService: AuthService) {

    // Raise Validation message
    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.AddReportForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    this.CompanyId = +localStorage.getItem('CompanyIdForUC');
    this.GetSiteList(this.CompanyId);
    this.Getdropdownlist()
    // Intialize searchCompanyForm form group for serach and validation
    this.AddReportForm = this.formBuilder.group({
      ReportType: ['Single'],
      MeterReportType: [''],
      ReportName: ['', [Validators.required]],
      SiteId: [''],
      PanelId: [''],
      EnergymeterId: ['']
    });
  }

  //  Called on change Site
  OnChangeSite(event) {
    this.AddReportForm.patchValue({
      SiteId: event.value
    });
    this.SiteId = event.value;
    this.SiteName = event.source.triggerValue;
    localStorage.setItem('LastSiteId', this.SiteId);
    localStorage.setItem('LastSiteName', this.SiteName);
    if (event.value != "") {
      this.GetPanelList(event.value);
    }
    if (event.value == "") {
      this.PanelList = [];
      this.EnergymeterList = [];
    }

    this.AddReportForm.patchValue({
      PanelId: '',
      EnergymeterId: ''
    });
  }

  // Get Site List
  GetSiteList(CompanyId) {
    this.commonservice.GetSiteList(CompanyId).subscribe(
      (result) => {
        this.SiteList = result;
        this.CheckForSingleEntry(this.SiteList, 1);
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Get Panel List
  GetPanelList(SiteId) {
    this.commonservice.GetPanelList(SiteId).subscribe(
      (result) => {
        this.PanelList = result;
        this.CheckForSingleEntry(this.PanelList, 2);
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Get Energy meter List
  GetEnergymeterList(SiteId, PanelId) {
    this.commonservice.GetEnergyMeterIdList(SiteId, PanelId, 'Y').subscribe(
      (result) => {
        this.newarr = [];
        this.SetObj = {};
        this.EnergymeterList = result;
        this.CheckForSingleEntry(this.EnergymeterList, 3);
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // Called on change Panel
  OnChangePanel(event) {
    this.AddReportForm.patchValue({
      PanelId: event.value
    });

    this.PanelId = event.value;
    this.PanelName = event.source.triggerValue;
    localStorage.setItem('LastPanelId', this.PanelId);
    localStorage.setItem('LastPanelName', this.PanelName);
    this.GetEnergymeterList(this.SiteId, this.PanelId);

    this.AddReportForm.patchValue({
      EnergymeterId: ''
    });
  }

  //  Called on chenge Energymeter
  OnChangeEnergymeter(event) {
    this.AddReportForm.patchValue({
      EnergymeterId: event.value
    });

    this.MeterName = event.source.triggerValue;
    localStorage.setItem('LastMeterId', this.MetermasterID.toString());
    localStorage.setItem('LastMeterName', event.value);
  }

  // check for single list and select option accordingly
  CheckForSingleEntry(obj, type) {
    this.list_of_functions = ['OnChangeCompany', 'OnChangeSite', 'OnChangePanel', 'OnChangeEnergymeter'];
    var count = Object.keys(obj).length;
    let newArray: any;
    if (count == 1) {
      if (type != 3) {
        newArray = obj.map(item => { return { value: item.CodeValue, source: { triggerValue: item.CodeDisplayText } }; });
      }
      else {
        newArray = obj.map(item => { return { value: item.CodeDisplayText, source: { triggerValue: item.CodeValue } }; });
      }
    }

    if (newArray && newArray.length > 0) {
      let methodName = this.list_of_functions[type];
      this[methodName](newArray[0]);
    }
  }

  // On Change Radio Button
  radioChange(type) {
    this.IsreadOnly = false;
    this.AddReportForm.patchValue({
      ReportName: ''
    });
    if (type == 'Single') {
      this.isDisplayCombo = true;
    }
    else {
      this.isDisplayCombo = false;
    }
  }

  // Save Report
  SaveReport() {
    this.errorMsg = '';
    this.successMsg = '';

    this.CheckMeterNameExist();
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }

  // On Change Meter Report Type
  OnChangeMRT(event) {
    if (event.value == 0) {
      this.IsreadOnly = true;
      this.AddReportForm.patchValue({
        ReportName: 'Daily Report'
      });
    }
    else {
      this.IsreadOnly = false;
      this.AddReportForm.patchValue({
        ReportName: ''
      })
    }
  }

  // Check Meter Name Exist
  CheckMeterNameExist() {

    let ReportName = this.AddReportForm.value.ReportName;
    let EnergymeterID = this.AddReportForm.value.EnergymeterId;

    this.reportservice.CheckMeterNameExist(ReportName, EnergymeterID).subscribe(
      (result) => {
        if (result) {
          if (result.Response == 'Exist') {
            this.errorMsg = 'Report Name already exist with same MeterId';
            return false;
          }
          else {
            if (this.isDisplayCombo == true) {
              this.AddReportForm.controls['SiteId'].setValidators(Validators.required);
              this.AddReportForm.controls['SiteId'].updateValueAndValidity();
              this.AddReportForm.controls['PanelId'].setValidators([Validators.required]);
              this.AddReportForm.controls['PanelId'].updateValueAndValidity();
              this.AddReportForm.controls['EnergymeterId'].setValidators([Validators.required]);
              this.AddReportForm.controls['EnergymeterId'].updateValueAndValidity();
            }

            if (this.AddReportForm.invalid) {
              this.AddReportForm.updateValueAndValidity();
              this.displayMessage = this.genericValidator.processMessages(this.AddReportForm, true);
              return;

            }

            let reqObj = {
              ReportName: this.AddReportForm.value.ReportName,
              CompanyId: this.CompanyId,
              CompSiteId: this.AddReportForm.value.SiteId ? this.AddReportForm.value.SiteId : 0,
              CompPanelId: this.AddReportForm.value.PanelId ? this.AddReportForm.value.PanelId : 0,
              EnergymeterMasterID: this.AddReportForm.value.EnergymeterId ? this.AddReportForm.value.EnergymeterId : 0,
              IsForChildData: 'N'
            };

            this.reportservice.SaveReportConfigData(reqObj).subscribe(
              (result) => {
                if (result) {
                  this.successMsg = 'Report data saved successfully';
                  this.displayMessage = this.genericValidator.processMessages(this.AddReportForm, false);
                }
              },
              (error) => {
                this.errorMsg = error;
                this.errorMsg = 'Report Name already exist with same MeterId';
              }
            );
          }
        }
      },
      (error) => {
        this.errorMsg = error;
        if (EnergymeterID == "" || ReportName == "") {
          this.errorMsg = "Please select Required Fields  !"
        }

      }
    )
  }
  Getdropdownlist() {
    let reqpara = 'ReportType';
    this.GSMConfigService.Getdropdownlist(reqpara).subscribe(
      (result) => {
        this.DropDownList = result;
        this.ReporttypeList = this.DropDownList['listReportType'];

      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }
  onKeypressEvent(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;
    console.log(inputElement.value);
    if (inputElement.value != null || inputElement.value != "") {
      this.successMsg = ""
      this.errorMsg = ""
    }
  }
}

